import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const FormCustomLayoutFieldWidget: WidgetRegistryEntry = {
  name: "FormCustomLayoutField",
  component: () =>
    import("./form-custom-layout-field-widget.component").then((m) => m.FormCustomLayoutFieldWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.FormCustomLayoutFieldWidgetConfiguration)
};
